import { defaultDateConfig } from '@vista/i18n';
import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const defaultOccDateConfig = Object.assign(Object.assign({}, defaultDateConfig), { startWeekOnSunday: false });
export const occDateConfigValidator = Validator.object({
    formats: Validator.object({
        iso: nonEmptyStringValidator,
        dateLong: nonEmptyStringValidator,
        dateShort: nonEmptyStringValidator,
        dateDefault: nonEmptyStringValidator,
        timeLong: nonEmptyStringValidator,
        timeShort: nonEmptyStringValidator,
        timeDefault: nonEmptyStringValidator
    }),
    ianaTimeZoneName: Validator.optional(nonEmptyStringValidator),
    ordinalStringFormatter: Validator.fn(),
    startWeekOnSunday: Validator.boolean()
});
